import gql from 'graphql-tag'

const CLAIMS_CREDITS = gql`
  query ClaimsCredits($type: String, $pagination: Pagination, $sort: Sort) {
    claimsCredits(type: $type, pagination: $pagination, sort: $sort) {
      total
      page
      last
      data {
        uid
        yyyymmdd
        credits
        type
      }
    }
  }
`

export { CLAIMS_CREDITS }